import createStyles from "@mui/styles/createStyles";
import makeStyles from "@mui/styles/makeStyles";
import { padding } from "@mui/system";
import { IDarkTheme } from "styles/darkTheme";

const styles = makeStyles((theme: IDarkTheme) =>
  createStyles({
    featureTitle: {
      fontWeight: theme.fontWeight.big,
      fontSize: "32px",
      color: theme.colors.neutrals.neturals_100,
      lineHeight: "56px",
      "@media (max-width: 899px)": {
        fontSize: "24px",
        fontWeight: theme.fontWeight.bold
      }
    },
    featureDescription: {
      fontWeight: theme.fontWeight.normal,
      fontSize: theme.fontSize.heading_5,
      lineHeight: theme.fontSize.heading_5,
      color: theme.colors.neutrals.neutrals_80,
      "@media (max-width: 899px)": {
        fontSize: "16px",
        fontWeight: theme.fontWeight.medium
      }
    },
    hidden: {
      visibility: "hidden"
    },
    rearImg: {
      position: "absolute",
      left: "0",
      top: "70px"
    },
    frontImg: {
      position: "absolute",
      left: "130px",
      top: "280px"
    },
    getInRight: {
      animation: "$inRight 2s"
    },
    getInLeft: {
      animation: "$inLeft 2s"
    },
    slackUrl: {
      textTransform: "none",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      textDecoration: "none",
      fontFamily: "Poppins",
      fontSize: "16px",
      fontWeight: "bold",
      color: theme.colors.neutrals.neutrals_80,
      width: "75%",
      padding: "20px",
      borderRadius: "8px",
      border: `solid 2px ${theme.colors.neutrals.neutrals_80}`,
      marginLeft: "auto",
      marginRight: "auto",
      marginTop: "16px",
      "@media (max-width: 899px)": {
        padding: "12px",
        width: "auto"
      }
    },
    bubble: {
      "@media (max-width: 600px)": {
        height: "500px"
      }
    },
    slackIcon: {
      width: "20px",
      height: "20px",
      marginRight: "8px"
    },
    "@keyframes inRight": {
      "0%": {
        transform: "translateX(30vw)",
        opacity: "0"
      },
      "100%": {
        transform: "none",
        opacity: "1"
      }
    },
    "@keyframes inLeft": {
      "0%": {
        transform: "translateX(-30vw)",
        opacity: "0"
      },
      "100%": {
        transform: "none",
        opacity: "1"
      }
    }
  })
);

export default styles;
